// Packages
const resolveConfig = require('tailwindcss/resolveConfig')
import { getImage, IGatsbyImageData, withArtDirection } from 'gatsby-plugin-image'
import tailwindConfig from '../../tailwind.config.js'
export const {theme} = resolveConfig(tailwindConfig)

type getValueFromScreenSizeProps = {
  values: 
    {
      desktop: string
      mobile: string
      tablet: string
    }
  screenBreakpoints?: {
    desktop: number
    mobile: number
    tablet: number
  },
  windowWidth: number
}
const screenSizeDefaultProps = {
  screenBreakpoints: {
    desktop: parseInt(theme.screens.desktop.min) -1,
    desktopMax: parseInt(theme.screens.desktop.max),
    mobile: parseInt(theme.screens.mobile.min) - 1,
    mobileMax: parseInt(theme.screens.mobile.max),
    tablet: parseInt(theme.screens.tablet.min) - 1,
    tabletMax: parseInt(theme.screens.tablet.max),
  }
}
export const screenSizeMaxDefaultProps = {
  screenBreakpoints: {
    desktop: parseInt(theme.screens.desktop.max),
    mobile: parseInt(theme.screens.mobile.max),
    tablet: parseInt(theme.screens.tablet.max),
  }
}
export const getValueFromScreenSize:Function = (propsPassed: getValueFromScreenSizeProps) => {
  const props = {
    ...propsPassed,
    screenBreakpoints: {
      ...screenSizeDefaultProps.screenBreakpoints, ...propsPassed.screenBreakpoints
    }
  };
  if (props.windowWidth === 0) return props.values["desktop"]
  return props.windowWidth > props.screenBreakpoints.tablet
  ? props.windowWidth > props.screenBreakpoints.desktop
    ? props.values["desktop"]
    : props.values["tablet"]
  : props.values["mobile"]
}

type getImageFromScreenSizeProps = {
  images: 
    {
      desktop: IGatsbyImageData
      mobile: IGatsbyImageData
      tablet: IGatsbyImageData
    }
  screenBreakpoints?: {
    desktop: number
    mobile: number
    tablet: number
  },
}
export const getImageFromScreenSize:Function = (propsPassed: getImageFromScreenSizeProps) => {
  const props = {
    ...propsPassed,
    screenBreakpoints: {
      ...screenSizeMaxDefaultProps.screenBreakpoints, ...propsPassed.screenBreakpoints
    }
  };
  return withArtDirection(getImage(props.images["desktop"]), [
    {
      image: getImage(props.images["tablet"]),
      media: `(max-width: ${props.screenBreakpoints.tablet}px)`
    },
    {
      image: getImage(props.images["mobile"]),
      media: `(max-width: ${props.screenBreakpoints.mobile}px)`
    }
  ])

}